'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;

    this.data = {};
  }

  $onInit() {
    this.getPeripheral(this.$stateParams.id);

    this.$scope.$watch('pEditCtrl.data.version', (version) => {
      if (version !== undefined && version !== null && version) {
        this.data.buildNumber = parseInt(version.replace(/\./g, ''));
      }
    });
  }

  getPeripheral(id) {
    this.$http.get(`/api/peripherals/${id}`).then(res => {
      this.data = res.data;
    });
  }

  update() {
    this.$http.put(`/api/peripherals/${this.$stateParams.id}`, this.data).then(res => {
      this.$state.go('peripheral');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/peripheral/edit/edit.controller.js